import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";

const CartItem = (props) => {
  const { picture, brand, name, points, totalCart, quantity, userPoints, t, itemDetails, isApiRunning } =
    props;
  const [canAdd, setCanAdd] = useState(false);

  const canAddItem = () => {
    const { max_qty = null, qty_ordered = null, stock = 0 } = itemDetails ?? {};
    if (userPoints - totalCart >= points && stock > quantity) {
      if (max_qty) {
        const maxOrders = qty_ordered ? max_qty - qty_ordered : max_qty;
        if (maxOrders > quantity) {
          setCanAdd(true);
        } else {
          setCanAdd(false);
        }
      }
      else {
        setCanAdd(true);
      }
    } else {
      setCanAdd(false);
    }
  };

  useEffect(() => {
    canAddItem();
  });
  return (
    <div className="cart_item">
      <div className="product_picture">
        <img src={picture} alt="" />
      </div>

      <div className="product_infos">
        <div className="product_brand">{brand}</div>
        <div className="product_name">{name}</div>
        <div className="product_price">
          {points} {t("points")}
        </div>
      </div>

      <div className="product_qty">
        <div
          className={canAdd ? "add_one" : "add_one hide"}
          onClick={canAdd && !isApiRunning ? props.addOne : null}
        ></div>
        <div className="qty">x{quantity}</div>
        <div className="remove_one" onClick={props.removeOne}></div>
      </div>

      <div className="product_del" onClick={props.removeProduct}></div>
    </div>
  );
};

export default withTranslation()(CartItem);
